export default __webpack_public_path__ + "static/media/punte alberete 1 P.fe09e7b2.mp3";